/**
 * Text matching for search and "contains" filters (TLB-1, UX-6). People type in English and Arabic,
 * so matching ignores case, Latin accents, Arabic diacritics (tashkeel, tatweel) and the common
 * spelling variants of alef, yeh and teh marbuta.
 */

const LATIN_MARKS = /[̀-ͯ]/g;
const ARABIC_MARKS = /[ً-ٰٟۖ-ۭـ]/g;
const ARABIC_VARIANTS: readonly [RegExp, string][] = [
  [/[آأإٱ]/g, 'ا'], // آ أ إ ٱ → ا
  [/ى/g, 'ي'], // ى → ي
  [/ة/g, 'ه'], // ة → ه
  [/ؤ/g, 'و'], // ؤ → و
  [/ئ/g, 'ي'], // ئ → ي
];

export function normalizeText(text: string): string {
  let value = text.normalize('NFKD').replace(LATIN_MARKS, '').replace(ARABIC_MARKS, '');
  for (const [pattern, replacement] of ARABIC_VARIANTS) value = value.replace(pattern, replacement);
  return value.toLowerCase().replace(/\s+/g, ' ').trim();
}

/** Whether `text` contains `query` after normalization; an empty query matches everything. */
export function textContains(text: string, query: string): boolean {
  const needle = normalizeText(query);
  return needle === '' || normalizeText(text).includes(needle);
}
